export default {"src":"/_next/static/media/clouds1.07b055dc.svg","height":152,"width":200,"blurWidth":0,"blurHeight":0};